<template>
  <b-card
    class="card-tiny-line-stats"
    body-class="pb-50"
  >
    <div class="d-flex justify-content-between align-content-center">
      <h6>
        {{ $t('Loan Awaiting Disbursement') }}
      </h6>
      <feather-icon
        icon="RotateCwIcon"
        class="cursor-pointer"
        @click="fetchPendingLoanRequest"
      />
    </div>

    <h2 class="font-weight-bolder mb-1">
      {{ pendingLoanValue }}
    </h2>

    <!-- chart -->
    <!-- <vue-apex-charts
      height="70"
      :options="statisticsOrder.chartOptions"
      :series="data.series"
    /> -->
    <Spinner :show="isLoadingPendingLoanRequest" />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import useToastAlert from '../../../composable/useToast'
import Spinner from '@/views/components/spinner/Spinner.vue'

export default {
  components: {
    BCard,
    Spinner,
  },
  setup() {
    const {
      getPendingLoanRequest,
    } = useActions({
      getPendingLoanRequest: 'dashboard/getPendingLoanRequest',
    })

    const { toastAlert } = useToastAlert()
    const pendingLoanValue = ref(null)

    const isLoadingPendingLoanRequest = ref(false)

    const fetchPendingLoanRequest = async () => {
      try {
        isLoadingPendingLoanRequest.value = true
        const response = await getPendingLoanRequest()

        const { status, data } = response
        if (status === 200 && data) {
          pendingLoanValue.value = data.totalPendingLoanDisbursement
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingPendingLoanRequest.value = false
      }
    }

    onMounted(async () => {
      await fetchPendingLoanRequest()
    })

    return {
      pendingLoanValue,
      isLoadingPendingLoanRequest,
      fetchPendingLoanRequest,
    }
  },
}
</script>

<style scoped>
.card .card-header {
    padding: 0.5rem 0;
}
 /* .card-body {
    padding: 0.8rem;
} */
</style>
